/** "bandcamp.com/x" → "https://bandcamp.com/x"; returns null if it still isn't a usable URL. */
export function normalizeUrl(raw: string): string | null {
  let s = raw.trim();
  if (!s) return null;
  if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(s)) s = `https://${s}`;
  try {
    const u = new URL(s);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
    if (!/^[^.\s]+\.[^.\s]{2,}/.test(u.hostname)) return null;
    return u.toString();
  } catch {
    return null;
  }
}
